import React from 'react';
import PropTypes from 'prop-types';
import { EmphasisTag, I18nText } from '@welldev-group/react-comp-lib';

const colorStatusMap = {
  Submitted: {
    colorType: 'warning',
    text: <I18nText id="support.ticket.state.submitted" />,
  },
  Open: {
    colorType: 'danger',
    text: <I18nText id="support.ticket.state.open" />,
  },
  Ready: {
    colorType: 'neutral',
    text: <I18nText id="support.ticket.state.ready" />,
  },
  Resolved: {
    colorType: 'success',
    text: <I18nText id="support.ticket.state.resolved" />,
  },
};

const TicketStatus = props => {
  const { state, emphasisTagSize } = props;

  return (
    <EmphasisTag
      type={colorStatusMap[state].colorType}
      text={colorStatusMap[state].text}
      size={emphasisTagSize}
    />
  );
};

TicketStatus.defaultProps = {
  emphasisTagSize: 'tiny',
};

TicketStatus.propTypes = {
  emphasisTagSize: PropTypes.oneOf(['normal', 'small', 'tiny']),
  state: PropTypes.string.isRequired,
};

export default TicketStatus;
